import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { snackbarUtils } from "../../utils";
import { useLns } from "../../hooks/useLns";
import { useCreateApplication } from "../../hooks/useApplications";
import { useDeviceBrands } from "../../hooks/useDevices";

export default function ApplicationAddDialog(props) {
  const { open, handleClose } = props;
  const [id, setId] = useState();
  const [eu868profile_id, setEU868Profile_id] = useState();
  const [us915profile_id, setUS915Profile_id] = useState();
  const [au915profile_id, setAU915Profile_id] = useState();

  const { data: lns } = useLns();
  const { data: device_brands } = useDeviceBrands();
  const createApplicationMutation = useCreateApplication();

  const [lns_id, setLns] = useState();
  const [device_brand_id, setDevice_brand_id] = useState("");

  const addApplication = () => {
    //check name is not blank and route is not blank and api_key is not blank
    if (!id) {
      snackbarUtils.updateMessage("ID is required");
      return;
    }

    if (!lns_id) {
      snackbarUtils.updateMessage("LNS is required");
      return;
    }

    if (!device_brand_id) {
      snackbarUtils.updateMessage("Device Brand is required");
      return;
    }

    const data = {
      application_id: id,
      brand_id: device_brand_id,
      lns_id: lns_id,
      eu868_profile_id: eu868profile_id,
      us915_profile_id: us915profile_id,
      au915_profile_id: au915profile_id,
    };

    createApplicationMutation.mutate(data, {
      onSuccess: () => {
        snackbarUtils.updateMessage("Application added");
        handleClose();
      },
      onError: (error) => {
        if (error.response?.status === 409) {
          snackbarUtils.updateMessage("Application already exists");
        } else {
          snackbarUtils.updateMessage("Application add error");
        }
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add Application</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ py: 2 }}>
          <TextField
            id="id"
            label="Application ID"
            value={id}
            onChange={(e) => setId(e.target.value)}
            fullWidth
            required
          />
        </FormControl>
        <FormControl fullWidth sx={{ pb: 2 }}>
          <TextField
            id="eu868_profile_id"
            label="EU868 Profile ID"
            value={eu868profile_id}
            onChange={(e) => setEU868Profile_id(e.target.value)}
            fullWidth
            required
          />
        </FormControl>
        <FormControl fullWidth sx={{ pb: 2 }}>
          <TextField
            id="us915_profile_id"
            label="US915 Profile ID"
            value={us915profile_id}
            onChange={(e) => setUS915Profile_id(e.target.value)}
            fullWidth
            required
          />
        </FormControl>

        <FormControl fullWidth sx={{ pb: 2 }}>
          <TextField
            id="au915_profile_id"
            label="AU915 Profile ID"
            value={au915profile_id}
            onChange={(e) => setAU915Profile_id(e.target.value)}
            fullWidth
            required
          />
        </FormControl>

        <FormControl fullWidth sx={{ pb: 2 }}>
          <Autocomplete
            id="lns_id"
            options={lns}
            getOptionLabel={(option) => option.name}
            onChange={(event, newValue) => {
              setLns(newValue.id);
            }}
            renderInput={(params) => <TextField {...params} label="LNS" />}
          />
        </FormControl>
        <FormControl fullWidth sx={{ pb: 2 }}>
          <Autocomplete
            id="device_brand_id"
            options={device_brands}
            getOptionLabel={(option) => option.description}
            onChange={(event, newValue) => {
              setDevice_brand_id(newValue.id);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Device Brand" />
            )}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="outlined" onClick={addApplication}>
          Add Application
        </Button>
      </DialogActions>
    </Dialog>
  );
}
